import React from 'react'
import {
    Box,
    useColorMode,
    IconButton,
    Tooltip
} from '@chakra-ui/react'

const Header = () => {

    const { colorMode, toggleColorMode } = useColorMode()
    const bgColor = { light: 'gray.50', dark: 'gray.800' }

    return (
        <>
            <Box 
            as="header"
            role={'banner'}
            position={'fixed'}
            width={'100%'}
            zIndex={10}
            bg={bgColor[colorMode]}
            py={[1, 2]}
            mb={10}
            borderBottomWidth={'1px'}
            >
           <Tooltip
                aria-label={colorMode === 'light' ? 'Toggle dark mode' : 'Toggle light mode'}
                label={colorMode === 'light' ? 'Toggle dark mode' : 'Toggle light mode'}
                showDelay={1000}
                fontSize="xs"
              >
                <IconButton
                  bg={'transparent'}
                  color={'gray.500'}
                  aria-label={'Toggle color mode'}
                  onClick={toggleColorMode}
                  fontSize={'20px'}
                  icon={colorMode === 'light' ? 'moon' : 'sun'}
                />
              </Tooltip>
            </Box>
        </>
    )
}

export default Header
